/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LastName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function LastName({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/Details/LastName",
  isInvalid,
  onChange
  
}) {
  let isMedia = useIsMedia()
let profilePatientPersonLastNameValueData = fromData.useDataValue({ viewPath,
context: 'profile_patient',
path: 'person.last_name',
})
let profilePatientPersonLastNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'profile_patient',
path: 'person.last_name',
validate: fromValidate.name,
required: true,
})
let profilePatientPersonLastNameChangeData = fromData.useDataChange({ viewPath,
context: 'profile_patient',
path: 'person.last_name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={0}
 flexBasis={1}
 flexGrow={1}
 data="profile_patient.person.last_name"
 validate="/Data/validate.js name"
 required={true}
 invalid={!profilePatientPersonLastNameIsValidData}
 value={profilePatientPersonLastNameValueData}
 onChange={profilePatientPersonLastNameChangeData}
 size={isMedia.mobile ? "small" : "medium"}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Last name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 tabIndex={4}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}